// eslint-disable-next-line import/no-named-as-default
import i18n from "i18next";
import enTranslation from "./en/translation.json";
import trTranslation from "./tr/translation.json";
import LanguageDetector, {
  DetectorOptions,
} from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
const fallbackLng = ["tr"];
const availableLanguages = ["tr", "en"];

const options: DetectorOptions = {
  // order and from where user language should be detected
  order: ["navigator", "htmlTag", "path", "subdomain"],
  // keys or params to lookup language from
  lookupQuerystring: "lng",
  lookupCookie: "i18next",
  lookupLocalStorage: "i18nextLng",
  lookupFromPathIndex: 0,
  lookupFromSubdomainIndex: 0,

  // cache user language on
  caches: ["localStorage", "cookie"],
  excludeCacheFor: ["cimode"], // languages to not persist (cookie, localStorage)

  // optional htmlTag with lang attribute, the default is:
  htmlTag: document.documentElement,
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment,import/no-named-as-default-member
// @ts-ignore
// eslint-disable-next-line import/no-named-as-default-member
void i18n
  .use(LanguageDetector) // detect user language
  .use(initReactI18next) // pass the i18n instance to react-i18next.
  .init({
    lng: "tr", // if user computer language is not on the list of available languages, than we will be using the fallback language specified earlier
    debug: true,
    whitelist: availableLanguages,
    detection: options,
    load: "languageOnly",
    checkWhitelist: true,
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      tr: {
        translation: trTranslation,
      },
      en: {
        translation: enTranslation,
      },
    },
  })
  .then();

export default i18n;
